import { toast } from "react-hot-toast";
const toasterror = (message, props={}) => {
  toast.error(message, {
    id: message,
    ...props
  })
}

export { toasterror }